var map = {
	"./semiRing1.svg": "b4a7",
	"./semiRing2.svg": "3ee8",
	"./semiRing3.svg": "a085",
	"./semiRing4.svg": "a178",
	"./semiRing5.svg": "1683",
	"./semiRing6.svg": "0811"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "934f";